<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-ios-cart"></i>
        <div class="mg-l-20 mg-b-0">
          <h4>{{$t("stockout.缺货登记管理")}}</h4>
        </div>
      </div>
      <div class="tx-right">
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="supplier_name" href="javascript:;" class=" mg-r-15" @click="clearKey('name')">
          {{$t("stockout.供应商名：")}}
          <span class="mg-r-10">{{supplier_name}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="supplier_contacts" href="javascript:;" class=" mg-r-15" @click="clearKey('contacts')">
          {{$t("stockout.联系方式：")}}
          <span class="mg-r-10">{{supplier_contacts}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="supplier_status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t("stockout.状态：")}}
          <span class="mg-r-10">{{$t(statusArr[supplier_status])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_type" href="javascript:;" class=" mg-r-15" @click="clearKey('type')">
          {{$t("stockout.登记类型：")}}
          <span class="mg-r-10">{{$t(stockType[key_type])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="subUserName" href="javascript:;" class=" mg-r-15" @click="clearKey('subUserName')">
          {{$t("stockout.子账号：")}}
          <span class="mg-r-10">{{subUserName}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
        <a v-show="sku" href="javascript:;" class=" mg-r-15" @click="clearKey('sku')">
          SKU：
          <span class="mg-r-10">{{sku}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="dateFrom || dateTo" href="javascript:;" class=" mg-r-15" @click="clearKey('date')">
          {{$t(timeArr[dateType])}}：
          <span class="mg-r-10">{{dateFrom}} {{$t("stockout.至")}} {{dateTo}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>  
  </div>
</template>

<script>
export default {
  props: ["supplier_name","key_type", "supplier_contacts","supplier_status","supplier_id", "sku","subUserName", "subUserId","dateFrom", "dateTo","dateType", 'batchBool'],
  data(){
    return {
    	statusArr: arrDict.stockoutStatus,
      timeArr: arrDict.stockoutTime,
      stockType: arrDict.stockType,
    }
  },
  methods: {
  	clearKey(type) {
      this.$emit("clearKey", type);
   	},
  }
}
</script>

